import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Button, InputAdornment, Stack } from '@mui/material';
import { AutosizedTextField } from '../../../../../../../components/common/AutosizedTextField';
import { useContext, useReducer } from 'react';
import { DeviceControlDAO } from '../../../../../../../data/DeviceControlDAO/DeviceControlDAO';
import { AppMainViewContext } from '../../../../../../../ContextProviders/AppContextProvider';
import { Severity } from '../../../../../../../types/AppTypes';
import { DeviceConfigContext } from '../../../../../../../components/Device/Context/deviceConfigContext';
const manualSendReducer = (state, next) => {
    console.log(`manualSendReducer`, { state, next });
    return { ...state, ...next };
};
export const ManualSend = (props) => {
    const { state: { entity, broadcastScheduleObject, device, deviceConfig }, } = useContext(DeviceConfigContext);
    const [{ UserFunctions }] = useContext(AppMainViewContext);
    const [state, dispatch] = useReducer(manualSendReducer, { bytes: '', sending: false });
    const { bytes, sending } = state;
    const sendDevicePayloadBytes = async () => {
        if (device == null)
            return;
        dispatch({ sending: true });
        const { err, data } = await DeviceControlDAO.device.payload.send({ device, bytes });
        if (err || !data) {
            UserFunctions.setUserMessage({
                id: 'sendDevicePayloadBytes',
                type: 'MessageBar',
                severity: Severity.error,
                label: 'Error sending device payload bytes',
                content: err ? err.message : 'Failed to send!',
            });
        }
        dispatch({ sending: false, bytes: '' });
    };
    return (_jsxs(Stack, { sx: { width: '100%' }, children: [_jsx(AutosizedTextField, { placeholder: "bytes...", value: bytes?.replace(/([0-9a-fA-F]{2})(?!=(\s|$))/g, '$1 ').trimEnd() ?? '', onChange: (e) => {
                    console.log(`ManualSend onChange`, { value: e.target.value });
                    dispatch({ bytes: e.target.value.toUpperCase().replace(/[^0-9A-F]/g, '') });
                }, disabled: sending, slotProps: {
                    input: {
                        startAdornment: _jsxs(InputAdornment, { position: "start", children: ["0x", device?.deviceType?.toString(16).toUpperCase()] }),
                    },
                }, inputProps: {
                    inputMode: 'text',
                    pattern: '[0-9A-Fa-f]*',
                    maxLength: 128, // optional: limit length
                } }), _jsx(Button, { variant: "outlined", onClick: sendDevicePayloadBytes, disabled: bytes.length === 0 || bytes.length % 2 === 1 || sending, loading: sending, children: "Send" })] }));
};
